import gql from 'graphql-tag'
import { EntityFields, EnumFields } from '..'

export const ConditionTypeFragment = gql`
  fragment ConditionType on loans_condition_type{
    ${EntityFields}
    ${EnumFields}
  }
`
